import { Input, LinkBox, Box, Center, Flex } from "@chakra-ui/react";
import styled, { createGlobalStyle } from "styled-components";


const FontStyles = createGlobalStyle`

@font-face {
font-family: 'Gisha';
src: url('../fonts/gisha.ttf');
}
@font-face {
font-family: 'Gisha bold';
src: url('../fonts/gishabd.ttf');
}
`;

export default FontStyles;




export const RegisterBudget = styled.div`
width: 100%;
margin: 0;
padding: 0;
background-color: #eaeaea;
min-height: 88.1vh;
`;
export const RegisterBudgetResume = styled.div`
display: flex;
width: 100%;
min-width: 1200px;
max-width: 1340px;
/* border: 10px #eaeaea solid; */
padding: 0px 0px;
-webkit-border-radius: 15px;
-moz-border-radius: 15px;
border-radius: 15px;
position: relative;
margin-left: auto;
margin-right: auto;
margin-bottom: 10px;
`;
export const RegisterBudgetResumeLoading = styled.div`
width: 100%;
height: 600px;
position: absolute;
background-color: #ffffff;
align-items: center;
z-index: 9999;

.product {
height: 100%;
}
.resumo {
height: 100vh;
}
.modal {
width: 990px;
}

.historic {
width: 1120px;
}

.orcamento {
width: 100%;
height: 700px;
position: absolute;
margin-left: auto;
margin-right: auto;
}

.resumo {
height: 800px;
}
`;
export const RegisterBudgetResumeLoadingContent = styled.div`
width: 100px;
height: 100%;
position: relative;
margin-left: auto;
margin-right: auto;
display: flex;
align-items: center;
img {
width: 100px;
height: 100px;
position: relative;
margin-left: auto;
margin-right: auto;
}
`;
export const RegisterBudgetResumeContent = styled.div`
width: 98%;
margin-top: 1rem;
`;
export const RegisterBudgetResumeContentFilter = styled.div`
position: relative;
margin-left: auto;
margin-right: auto;
display: flex;
font-family: Akrobat;
justify-content: center;
margin: 40px 0;
color: rgb(61, 61, 61);
`;
export const RegisterBudgetResumeContentFilterSelector = styled.div`
-webkit-border-radius: 3px;
-moz-border-radius: 3px;
border-radius: 3px;
padding: 0 5px;
font-size: 16px;
font-family: 'Akrobat';
letter-spacing: 0.03rem;
margin: 0 10px;
display: flex;
align-items: center;
label{
font-family: Akrobat ExtraBold;
}

`;
export const RegisterBudgetResumeContentFilterButton = styled.button`
background-color: #ff7e00;
color: #fff;
border-radius: 5px;
padding: 0 13px;
height: 38px;
margin-left: 10px;
`;
export const RegisterBudgetResumeContentFilterButtonWhite = styled(RegisterBudgetResumeContentFilterButton)`
background-color: rgb(233, 231, 231);
font-family: Akrobat;
color: rgb(78, 78, 78);
`;
export const RegisterBudgetResumeContentSubtext = styled(RegisterBudgetResumeContent)`
height: 20px;
position: relative;
top: -50px;
h1 {
font-family: "Akrobat SemiBold";
font-size: 20px;
color: rgb(61, 61, 61);
text-align: center;
}
`;
export const RegisterBudgetModal = styled.div`
width: 100%;
height: 100vh;
background-color: rgba(0, 0, 0, 0.404);
// background-color: transparent;
position: fixed;
top: -0px;
z-index: 99999;
display: flex;
align-items: center;

.cubagem {
width: 100%;
height: 100vh;
background-color: rgba(0, 0, 0, 0.404);
// background-color: transparent;
position: fixed;
top: -0px;
z-index: 99999;
display: flex;
align-items: center;
}

.frete {
width: 100%;
height: 100vh;
background-color: rgba(0, 0, 0, 0.404);
// background-color: transparent;
position: fixed;
top: -0px;
z-index: 99999;
display: flex;
align-items: center;
}
`;
export const RegisterBudgetModalContent = styled.div`
max-width: 1360px;
height: 80%;
box-shadow: 2px 2px 15px 2px rgba(228, 228, 228, 0.493);
background-color: #ffffff;
position: relative;
margin-left: auto;
margin-right: auto;
align-self: center;
border: 30px solid white;
`;
export const RegisterBudgetModalContentLayout = styled(RegisterBudgetModalContent)`
width: 800px;
height: 615px;
border: none;

`;
export const RegisterBudgetModalContentParceiro = styled(RegisterBudgetModalContent)`
height: auto;
`;
export const RegisterBudgetModalContentFilter = styled.div`
position: relative;
margin-left: auto;
margin-right: auto;
display: flex;
justify-content: center;
margin-top: 20px;
color: #ff7e00;
`;
export const RegisterBudgetModalContentFilterParceiro = styled(RegisterBudgetModalContentFilter)`
position: relative;
margin-left: auto;
margin-right: auto;
display: flex;
justify-content: center;
margin-top: 5px;
color: #ff7e00;
`;
export const RegisterBudgetModalContentFilterSelector = styled.div`
background-color: #fff;
-webkit-border-radius: 3px;
-moz-border-radius: 3px;
border-radius: 3px;
padding: 0 5px;
font-size: 16px;
font-family: "Akrobat ExtraBold";
letter-spacing: 0.03rem;
color: #ff7e00;
margin: 0 10px;
display: flex;
align-items: center;

.product {
background-color: #fff;
-webkit-border-radius: 3px;
-moz-border-radius: 3px;
border-radius: 3px;
padding: 0 5px;
font-size: 16px;
font-family: "Akrobat ExtraBold";
letter-spacing: 0.03rem;
margin: 0 10px;
display: flex;
align-items: center;
position: relative;
top: -20px;

input {
height: 32px;
border: 1px solid #919aae;
color: #919aae;
margin-left: 3px;
border-radius: 3px;
outline: none;
}
}

input {
height: 32px;
border: 1px solid #919aae;
color: #919aae;
margin-left: 3px;
border-radius: 3px;
outline: none;
}
`;
export const RegisterBudgetResumeContentModalFilterButton = styled.button`
background-color: #ff7e00;
color: #fff;
border-radius: 5px;
padding: 0 13px;
height: 38px;
margin-left: 10px;
`;
export const RegisterBudgetResumeContentModalFilterButtonWhite = styled(RegisterBudgetResumeContentModalFilterButton)`
background-color: rgb(233, 231, 231);
color: rgb(78, 78, 78);
border-radius: 5px;
padding: 0 13px;
height: 38px;
margin-left: 10px;
`;
export const ModalContentGrid = styled.div`
// width: 95%;
height: 90%;
position: relative;
margin-left: auto;
margin-right: auto;
// overflow-x: scroll;
overflow-y: auto;
// background-color: rgb(248, 248, 248);
// border: 15px solid white;
`;
export const ModalContentGridLoading = styled.div`
width: 100%;
height: 100%;
position: absolute;
background-color: #ffffff;
align-items: center;
z-index: 9999;
`;
export const ModalContentGridLoadingContent = styled.div`
width: 100px;
height: 100%;
position: relative;
margin-left: auto;
margin-right: auto;
display: flex;
align-items: center;
img {
width: 100px;
height: 100px;
position: relative;
margin-left: auto;
margin-right: auto;
}
`;
export const ModalContentGridColumn = styled.div`
margin-top: 20px;
font-size: 14px;
color: #919aae;
font-weight: 300;
position: relative;
.border {
width: 100px;
border: 1px #ff7e00 solid;
border-radius: 5px;
width: 110px;
margin-right: 5px;
}

thead {
// width: 700px;
// border-bottom: 2px solid #ff7e00;
tr {
th {
width: 160px;
color: #ff7e00;
font-family: "Akrobat ExtraBold";
font-size: 15px;

&.checkbox-size {
width: 40px;
min-width: 40px;
max-width: 40px;
}
&.title-rotate {
transform: rotate(-90deg);
min-width: 40px;
max-width: 40px;
}
&:nth-child(1) {
width: 30px;
}
}

&:nth-child(1) {
width: 30px;
}
}
}

tbody {
width: 700px;
tr {
margin: 10px 0;

&:nth-child(even) {
background-color: #fcfdfc;
}

&:nth-child(1) {
width: 30px;
}

td {
width: 160px;
text-transform: uppercase;
text-align: center;
font-family: "Akrobat";
font-size: 15px;
padding: 0 10px;
height: 50px;

&:nth-child(1) {
width: 30px;
}

&.checkbox-size {
width: 40px;
position: relative;
top: -10px;
min-width: 40px;
max-width: 40px;
}

&.cub {
display: flex;
align-items: center;

text-transform: inherit;

a {
text-decoration: none;
display: flex;
color: #ff7e00;
}

.icon {
margin-right: 5px;
}
}

&.btn {
padding: 0;
}
}
}
}
`;
export const RegisterBudgetModalContentDadosParceiro = styled.div`
width: 800px;
height: 70%;
position: relative;
display: flex;
align-self: center;
margin-top: 5px;
// background-color: #ff7e00;
overflow: auto;
display: flex;
justify-content: space-between; 
`;
export const RegisterBudgetModalContentDadosParceiroColumn = styled.div`
width: 45%;
height: 100%;
position: relative;
`;
export const RegisterBudgetModalContentDadosParceiroColumnTitle = styled.div`
font-size: 20px;
color: black;
font-family: 'Akrobat', sans-serif; 
margin-bottom: 15px;
`;
export const RegisterBudgetModalContentDadosParceiroColumnSubtitle = styled.div`
width: 100%;
position: relative;
float: left;

p{
color: #80bd01;
font-size: 19px;
font-family: 'Akrobat'; 
}
`;
export const SubtitleEnd = styled(RegisterBudgetModalContentDadosParceiroColumnSubtitle)`
margin-top: 10px;
`;
export const FlexHeader = styled(Box)`
background-color: #F15422;
clip-path: polygon(80% 0, 85% 19%, 88% 45%, 91% 65%, 94% 100%, 39% 100%, 0 100%, 0 0);
`;
export const Embalagem = styled(Center)`
  font-family:'Gisha';
`;

export const RegisterBudgetModalContentDadosParceiroColumnSublinhado = styled.div`
width: 90%;
height: 1px;
position: relative;
background-color: #80bd01;
`;
export const RegisterBudgetModalContentDadosParceiroColumnItem = styled.div`
width: 100%;
height: 20px;
position: relative;
float: left;
margin-top: 10px;
// background-color: skyblue;

p{
font-size: 16px;
font-family: 'Akrobat';
color:rgb(61, 61, 61);

strong{
font-size: 16px;
font-family: 'Akrobat';
color:rgb(61, 61, 61);
}
}
`;
export const RegisterBudgetModalAbaProduto = styled(Center)`
width: 100%;
height: 100vh;
background-color: rgba(0, 0, 0, 0.404);
position: fixed;
top: -0px;
z-index: 99999;
display: flex;
align-items: center;

.cubagem {
width: 100%;
height: 100vh;
background-color: rgba(0, 0, 0, 0.404);
// background-color: transparent;
position: fixed;
top: -0px;
z-index: 99999;
display: flex;
align-items: center;
}

.frete {
width: 100%;
height: 100vh;
background-color: rgba(0, 0, 0, 0.404);
// background-color: transparent;
position: fixed;
top: -0px;
z-index: 99999;
display: flex;
align-items: center;
}
`;
export const RegisterBudgetModalContentPropostaClass = styled(RegisterBudgetModalContent)`
width: 1430px;
position: relative;
margin-left: auto;
margin-right: auto;
// display: flex;
align-self: center;
top:0px;
left: 0px;
box-shadow: 2px 2px 15px 2px rgba(228, 228, 228, 0.493);
background-color: #ffffff;
// border: 15px solid white;
@media (max-width: 1400px) {
    width: 1200px;
    margin-right: 15rem;
  }
`;
export const RegisterBudgetModalContentProposta = styled.div`
width: 100%;
height: 100%;
// background-color: royalblue;
overflow-y: scroll;
`;
export const RegisterBudgetModalContentPropostaButtonClose = styled.div`
position: absolute;
float: right;
right: -282px;
`;
export const RegisterBudgetModalContentPropostaHeader = styled.div`
img{
    /* margin-top: 5rem; */
    width:100%;
    display:block;
    object-fit:cover;
    position:relative;
    float:left;
}

`;
export const BoxHeader = styled(Box)`
height:20px;
position:relative;
z-index:99999;
font-size:20px;
color:black;
font-family:'Roboto';
width: 230px;
left: 507px;
top: -85px;
`;
export const RegisterBudgetModalContentPropostaHeaderNumeroProp = styled.div`
color: white;
`;

export const RegisterBudgetModalContentPropostaHeaderDataProp = styled.div`
color: white;
`;

export const RegisterBudgetModalContentPropostaSubheaderContent = styled(Flex)`
width:100%;
height: 7vh;
align-items: center;
background-color:#F15422;
p{
    color: white;
}
`;
export const TitleTableProduct = styled(Flex)`
width:980px;
height: 7vh;
margin-top: 1rem;
align-items: center;
background-color:#F15422;
@media (max-width: 1400px) {
    margin-top: 9rem;
  }
p{
    color: white;
}
`;
export const RegisterBudgetModalContentPropostaCard = styled.div`
width:100%;
position: relative;
float: left;
font-family:'Gisha';
`;
export const RegisterBudgetModalContentPropostaCardContent = styled.div`
width:980px;
height: 350px;
border-top: 5px solid #F15422;
position: relative;
margin-left:auto;
margin-right:auto;
`;
export const RegisterBudgetModalContentPropostaCardContentTitle = styled.div`
width:980px;
height: 5px;
position: relative;
top: -30px;
left: 0px;
background-color:black;
p{
font-size: 16px;
color: white;
position: relative;
left: 10px;
font-family: 'Roboto', sans-serif;
}
`;
export const RegisterBudgetModalContentPropostaCardContentImageCard = styled.div`

width:100%;
position: relative;
height: 370px;
float:left;
border: 0.6px solid rgb(0,0,0,0.1);

img{
border: 0.6px solid rgb(0,0,0,0.1);
width:auto;
height: 368px;

}

span{
width: 120px;
position: absolute;
font-size: 15px;
font-family: 'Akrobat SemiBold';
color: rgb(61, 61, 61);
left: 3%;
top: 93%;
background-color: white;
border-radius: 5px;

}
`;
export const RegisterBudgetModalContentPropostaCardContentImageCardEmbalagem = styled.div`
width:100%;
height: 400px;
position: relative;
float:left;

img{
width:auto;
height: 400px;
}

span{
width: 120px;
position: absolute;
font-size: 15px;
font-family: 'Akrobat SemiBold';
color: rgb(61, 61, 61);
left: 3%;
top: 93%;
background-color: white;
border-radius: 5px;

}
`;
export const RegisterBudgetModalContentPropostaCardContentDados = styled.div`
width:600px;
height: 219px;
position: relative;
float:left;
top: -40px;
left: 20px;
`;
export const RegisterBudgetModalContentPropostaCardContentDadosDescricao = styled.div`
width:600px;
height: 110px;
position: relative;
float:left;
top: 0px;
left: 0px;
`;
export const RegisterBudgetModalContentPropostaCardContentDadosDescricaoTitle = styled.div`
width:600px;
height: 55px;
position: relative;
float: left;
font-family: 'Roboto', sans-serif;
top: 20px;
left: 20px;

img{
width:28px;
height: 33px;
position: relative;
float: left;
}

p{
width:28px;
height: 33px;
position: relative;
float: left;
font-size: 17px;
font-family: 'Roboto', sans-serif;
font-weight:600;
color: black;
top:10px;
left:10px;
}
`;
export const RegisterBudgetModalContentPropostaCardContentDadosDescricaoSubtitle = styled.div`
width:500px;
height: 55px;
position: relative;
float: left;
font-family: 'Roboto', sans-serif;
top: 20px;
left: 20px;

p{
width:500px;
position: relative;
float: left;
font-size: 14px;
color: rgb(61, 61, 61);
font-family: 'Roboto', sans-serif;
top: -10px;
left: 0px;
}
`;
export const RegisterBudgetModalContentPropostaCardContentDadosDimensao = styled.div`
width:600px;
height: 110px;
position: relative;
float:left;
top: 0px;
left: 0px;
`;
export const RegisterBudgetModalContentPropostaCardContentDadosDimensaoTitle = styled.div`
width:600px;
height: 55px;
position: relative;
float: left;
top: 20px;
left: 0px;

img{
width:25px;
height: 25px;
left:-8px;
position: relative;
}

p{
width:28px;
height: 33px;
position: relative;
float: left;
font-size: 17px;
font-family: 'Roboto', sans-serif;
font-weight:600;
color: black;
top:0px;
left:59px;
}
`;
export const RegisterBudgetModalContentPropostaCardContentDadosDimensaoSubtitle = styled.div`
width:500px;
height: 55px;
position: relative;
float: left;
font-family: 'Roboto', sans-serif;
top: 0px;
left: 20px;     

p{
width:500px;
position: relative;
float: left;
font-size: 14px;
color: rgb(61, 61, 61);
font-family: 'Roboto', sans-serif;
top: 0px;
left: 0px;

&:nth-child(2){
font-size: 10px;
top: 20px;
width:500px;
position: relative;
float: left;
font-family:'Roboto', sans-serif;
left: 0px;
}
}
`;
export const RegisterBudgetModalContentPropostaCardConfiguracaoItem = styled.div`
width: 978px;
height: auto;
background-color: white;
position: relative;
float: left;
left: 36px;
border-bottom: 1px solid #e5e6e6;
border-left: 1px solid #e5e6e6;
border-right: 1px solid #e5e6e6;

table{
width: 980px;
thead{
font-size: 14px;
font-family:'Roboto',sans-serif;
color: rgb(61, 61, 61);
th{
width: 80px;
font-family:'Roboto',sans-serif;
color: rgb(61, 61, 61);
}
}
tbody{
height: 45px;
font-size: 13px;
font-family:'Roboto',sans-serif;
text-align: center;
color: rgb(61, 61, 61);
td{
width: 80px;
font-family:'Roboto',sans-serif;
color: rgb(61, 61, 61);
}
} 
}
`;
export const RegisterBudgetModalContentPropostaCardContainer = styled.div`
margin-top: 5rem;
width: 100%;
height: 435px;
margin-left:auto;
margin-right: auto;
position: relative;
float: left;
align-items: center;
`;
export const RegisterBudgetModalContentPropostaCardContainerObservacoes = styled.div`
width: 978px;
height: 660px;
background-color: #ffffff;
margin-left:auto;
margin-right: auto;
position: relative;
`;
export const RegisterBudgetModalContentPropostaCardContainerObservacoesValor = styled.div`
width: 100%;
height: 30px;
background-color:#ff7e00;
margin-left:auto;
margin-right: auto;
display: flex;
justify-content: left;

strong{
width: 100%;
color: white;
font-size:14px;
font-family: 'Roboto',sans-serif;
position: relative;
top:10px;
left:10px;
text-align: center;
}
`;
export const RegisterBudgetModalContentPropostaCardContainerObservacoesTitle = styled.div`
width: 100%;
height: 30px;
background-color:#e5e6e6;
margin-left:auto;
margin-right: auto;
display: flex;
justify-content: left;

strong{
width: 100%;
color: black;
font-size:14px;
font-family: 'Roboto',sans-serif;
position: relative;
top:10px;
left:10px;
text-align: center;
}
`;
export const RegisterBudgetModalContentPropostaCardContainerObservacoesCondicao = styled.div`
width:100%;
height: 50px;
position: relative;
float: left;
margin-top: 8px;

`;
export const RegisterBudgetModalContentPropostaCardContainerObservacoesCondicaoLarge = styled(RegisterBudgetModalContentPropostaCardContainerObservacoesCondicao)`
height: 170px;
`;
export const RegisterBudgetModalContentPropostaCardContainerObservacoesCondicaoTitle = styled.div`
width:170px;
height: 50px;
position: relative;
float: left;
border-radius: 5px;
top: 2px;
left: 2px;
background-color: #d5d5d5;
display: flex;
align-items: center;

p{
width:100%;
font-size: 10px;
color: black;
position: relative;
text-align: center;
font-size: 12px;
font-family: 'Roboto', sans-serif;
}
`;
export const RegisterBudgetModalContentPropostaCardContainerObservacoesCondicaoData = styled.div`
width: 798px;
height: 50px;
position: relative;
float: left;
border-radius: 5px;
top: 2px;
left: 10px;
background-color: #f4f4f4;
display:flex;
align-items: center;																									
// style="width:520px;height: 57px;font-size: 10px;color: black;position: relative;text-align: left;left: 10px;top: 0px;font-family: 'Roboto', sans-serif;"
p{
width:90%;
font-size: 10px;
color: black;
position: relative;
text-align: left;
left: 10px;
font-size: 12px;
font-family: 'Roboto', sans-serif;
}
`;
export const RegisterBudgetModalContentPropostaCardContainerObservacoesCondicaoDataLarge = styled.div`									
height: 170px;
position: relative;
float: left;

`;
export const RegisterBudgetModalContentPropostaCardContainerObservacoesCondicaoDataMedium = styled.div`									
height: 80px;
position: relative;
float: left;


`;
export const RegisterBudgetContent = styled.div`
width: 98%;
max-width: 1366px;
height: auto;
margin-top: 15px;
margin-bottom: 80px;
background-color: white;
position: relative;
margin-left: auto;
margin-right: auto;
`;
export const RegisterBudgetContentLoading = styled.div`
width: 100%;
height: 100%;
position: absolute;
z-index: 9999;
background-color: white;
display: flex;
align-items: center;
`;
export const RegisterBudgetContentLoadingContent = styled.div`
width: 110px;
height: 100px;
position: relative;
margin-left: auto;
margin-right: auto;
`;
export const RegisterBudgetContentHeader = styled.div`
width: 100%;
height: 40px;
// background-color: sandybrown;
display: flex;
align-items: center;
`;
export const RegisterBudgetContentHeaderBudget = styled.div`
width: 100%;
height: 20px;
display: flex;
justify-content: flex-start;
align-items: center;

p{
width: 250px;
font-size: 16px;
font-family: 'Akrobat SemiBold';
color: rgb(61, 61, 61);;
margin-left: 20px;

strong{
font-size: 18px;
font-family: 'Akrobat ExtraBold';
color: #ff7e00;
}
}
`;
export const RegisterBudgetContentHeaderBudgetLinDiv = styled.div`
width: 78%;
height: 3px;
background-color: rgba(61, 61, 61, 0.131);

`;
export const RegisterBudgetContentDataProduct = styled.div`
width: 100%;
min-height: 40px;
margin-top: 10px;

`;
export const RegisterBudgetContentDataProductHeader = styled.div`
width: 100%;
height: 34px;
display: flex;
justify-content: flex-start;
align-items: center;
background-color: #80bd01;

span{
cursor: pointer;
}

`;
export const RegisterBudgetContentDataProductHeaderTitle = styled.div`
width: 150px;
height: 30px;
margin-left: 20px;
margin-right: 20px;
display: flex;
align-items: center;
cursor: pointer;
p{
font-size: 18px;
font-family: 'Akrobat';
color: white;
strong{
font-size: 18px;
font-family: 'Akrobat ExtraBold';
color: white;
}
}
`;
export const RegisterBudgetContentDataProductBody = styled.div`
width: 100%;
height: auto;
overflow-y: hidden;
overflow-x: scroll;
`;
export const RegisterBudgetContentDataProductBodyAbaProducts = styled.div`
width: 97%;
// min-height: 100px;
position: relative;
margin-left: auto;
margin-right: auto;
margin-top: 10px;
margin-bottom: 10px;
cursor: pointer;
`;
export const RegisterBudgetContentDataProductBodyAbaProductsLoading = styled.div`
width: 80%;
height: 30px;
position: relative;
margin-left: auto;
margin-right: auto;
display: flex;
justify-content: center;

img{
width: 400px;
height: 40px;
}
`;
export const RegisterBudgetContentDataProductBodyAbaProductsEmpty = styled.div`
width: 80%;
height: 35px;
position: relative;
margin-left: auto;
margin-right: auto;
margin-top: 10px;
align-items: center;
font-family: Akrobat;
display: flex;
justify-content: center;
p{
position: relative;
margin-left: auto;
margin-right: auto;
font-size: 22px;
font-family: 'Akrobat';
color: rgb(61, 61, 61);
}
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContent = styled.div`
width: 100%;
height: 100%;
font-family: Akrobat;
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentItem = styled.div`
width: 100%;
height: 35px;
margin-bottom: 7px;
background-color: #bebebe;
display: flex;
font-family: Akrobat;
justify-content: space-around;
align-items: center;
cursor: pointer;
span{
cursor: pointer;
}
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentItemTitle = styled.div`
width: 90%;
height: 90%;
display: flex;
align-items: center;
cursor: pointer;
p{
font-size: 18px;
font-family: 'Akrobat ExtraBold';
letter-spacing: 0.03rem;
color: white;
cursor: pointer;
}
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBody = styled.div`
width: 100%;
height: 100%;
display: none;
display: flex;
flex-direction: row;
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProduct = styled(LinkBox)`
width: 341px;
height: 1195px;
z-index: 99999;
position: relative;
margin-top: 30px;
border-width: 1px;
margin-bottom: 20px;
margin-left: 20px;
background-color: white;
border-radius: 3px;
box-shadow: 2px 2px 10px 2px rgba(0, 0, 0, 0.275);

&:nth-child(1){
margin-left: 10px;
}
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductTicket = styled.div`
width: 93px;
height: 28px;
border-top-left-radius: 5px;
border-top-right-radius: 5px;
position: absolute;
top:-30px;
background-color: #80bd01;
display: flex;
justify-content: center;
align-items: center;
p{
font-size: 14px;
font-family: 'Akrobat';
color: white;
strong{
font-family: 'Akrobat ExtraBold';
}
}
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductTicketLayout = styled.div`
width: 120px;
height: 28px;
border-top-left-radius: 5px;
border-top-right-radius: 5px;
position: absolute;
top:-30px;
left: 100px;
background-color: #ff7e00;
display: flex;
justify-content: center;
align-items: center;
p{
font-size: 14px;
font-family: 'Akrobat';
color: white;
strong{
font-family: 'Akrobat ExtraBold';
}
}
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductHeader = styled.div`
width: 97%;
height: 235px;
position: relative;
margin-left: auto;
margin-right: auto;
margin-top: 5px;
span{
cursor: pointer;
}
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductHeaderTitle = styled.div`
width: 100%;
height: 38px;
border-radius: 3px;
border: 0.5px solid rgb(177, 177, 177);
display: flex;
justify-content: space-between;
align-items: center;
p{
font-size: 16px;
font-family: 'Akrobat';
padding-left: 10px;
color: rgb(61, 61, 61);
}

span{
cursor: pointer;
}
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductHeaderImage = styled.div`
width: 133px;
height: 166px;
position: relative;
float: left;
border-radius: 5px;
margin-top: 15px;
border: 0.6px solid rgb(177, 177, 177);

img{
width: 100%;
display: flex;
object-fit: cover;
border-radius: 5px;
}
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductHeaderDados = styled.div`
width: 174px;
height: 164px;
position: relative;
float: left;
border-radius: 3px;
margin-top: 15px;
margin-left: 5px;
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductHeaderDadosDescricao = styled.div`
width: 100%;
height: 74px;
p{
font-size: 16px;
font-family: 'Akrobat';
color: black;
padding-top: 5px;
padding-left: 5px;
}
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductHeaderDadosVerifiqueCubagem = styled.div`
width: 100%;
height: 42px;
display: flex;
align-items: center;
margin-bottom: 10px;

button{
width: 100%;
height: 100%;
border-radius: 3px;
border: 0.6px solid rgb(177, 177, 177);
background-color: white;
display: flex;
justify-content: space-between;

p{
margin-right: 5px;
align-self: center;
font-size: 16px;
font-family: 'Akrobat';
color: rgb(61, 61, 61);
z-index: 99999;
.tooltiptext {
visibility: hidden;
width: 420px;
background-color: #555;
color: #fff;
text-align: center;
border-radius: 6px;
padding: 5px 0;
position: absolute;
z-index: 99999;
top: 45%;
left: 140%;
margin-left: -60px;
opacity: 0;
transition: opacity 0.3s;

table{
width: 100%;
z-index: 99999;
tr{
td{
margin: 10px;
}
}
}
}

.tooltiptext::after {
content: "";
position: absolute;
top: 0%;
left: 0%;
margin-left: -5px;
border-width: 5px;
border-style: solid;
z-index: 999999;
opacity: 1;
border-color: #555 transparent transparent transparent;
}
}

p:hover .tooltiptext {
visibility: visible;
opacity: 1;
z-index: 999999;
}

span{
margin-left: 10px;
background-position-x: 0px;
background-position-y: 8px;
}
// .icon-30{
//     width: 40px;
//     height: 40px;
//     position: relative;
//     background-size: 35px;
//     background-position-x: 0px;
//     background-position-y: 0px;

// }
}
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductHeaderDadosVerifiqueEstoque = styled.div`
width: 100%;
height: 42px;
// background-color: #f20000;
display: flex;
align-items: center;
margin-bottom: 10px;
button{
width: 100%;
height: 100%;
border-radius: 3px;
border: 0.6px solid rgb(177, 177, 177);
background-color: white;
display: flex;
justify-content: space-between;

p{
margin-right: 5px;
align-self: center;
font-size: 16px;
font-family: 'Akrobat';
color: rgb(61, 61, 61);
z-index: 99999;
.tooltiptext {
visibility: hidden;
width: 420px;
background-color: #555;
color: #fff;
text-align: center;
border-radius: 6px;
padding: 5px 0;
position: absolute;
z-index: 99999;
top: 76%;
left: 140%;
margin-left: -60px;
opacity: 0;
transition: opacity 0.3s;

table{
width: 100%;
z-index: 99999;
tr{
td{
margin: 10px;
}
}
}
}

.tooltiptext::after {
content: "";
position: absolute;
top: 0%;
left: 0%;
margin-left: -5px;
border-width: 5px;
border-style: solid;
z-index: 999999;
opacity: 1;
border-color: #555 transparent transparent transparent;
}
}

p:hover .tooltiptext {
visibility: visible;
opacity: 1;
z-index: 999999;
}

span{
margin-left: 10px;
background-position-x: 0px;
background-position-y: 8px;
}
// .icon-30{
//     width: 40px;
//     height: 40px;
//     position: relative;
//     background-size: 35px;
//     background-position-x: 0px;
//     background-position-y: 0px;

// }
}

`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfig = styled.div`
width: 97%;
height: 350px;
position: relative;
margin-right: auto;
margin-left: auto;
// background-color: #bebebe;
display: flex;
justify-content: space-between;

.frete{
height: 200px;
}


`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumn = styled.div`
width: 130px;
height: 100%;
`;

export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField = styled.div`
width: 100%;
height: 33px;
position: relative;
border-radius: 2px;
margin-bottom: 5px;
background-color: white;
display: flex;
align-items: center;

label{
position: absolute;
background-color: transparent;
color: black;
left:10px;
z-index: 8;

}
.large{
width: 315px;
height: 33px;
z-index: 1;
}


.large-emb{
width: 324px;
height: 40px;
z-index: 1;
}

.large-height{
height: 54px;
}

.large-height-emb{
height: 61px;
}

p{
font-size: 15px;
font-family: 'Akrobat';
color: rgb(61, 61, 61);
padding-left: 10px;

strong{
color: #f20000;
}
}

&:nth-child(2n+1){
background-color: #f2f2f2;
}

.transparent{
background-color: transparent;
}
select{
width: 100%;
height: 100%;
border: none;
outline: none;
-webkit-appearance: none;
-moz-appearance: none;
background-image: url("/images/arrow-down-green.png");
background-size: 15px 10px;
background-repeat: no-repeat;
background-position-x: 96%;
background-position-y: 50%;
background-color: transparent;
padding-left: 10px;
font-size: 14px;
font-family: 'Akrobat';
color: rgb(61, 61, 61);
}

input{
width: 100%;
height: 60%;
position: relative;
margin-left: 0.2rem;
margin-right: auto;
border-radius: 3px;
border: 0.3px solid rgb(174, 174, 174);
background-color: white;
font-size: 14px;
font-family: 'Akrobat SemiBold';
letter-spacing: 0.05rem;
outline: none;
-webkit-appearance: none;
-moz-appearance: none;
padding-left: 28px;
}

input[type="text"]{
font-size: 14px;
font-family: 'Akrobat SemiBold';
letter-spacing: 0.03rem;
}
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnLarge = styled(RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumn)`
width: 175px;
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnFieldCep = styled(RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField)`

input{
width: 80%;
height: 60%;
position: relative;
margin-left: auto;
margin-right: auto;
border-radius: 3px;
font-size: 14px;
font-family: 'Akrobat SemiBold';
letter-spacing: 0.03rem;
border: 0.3px solid rgb(174, 174, 174);
background-color: white;
outline: none;
-webkit-appearance: none;
-moz-appearance: none;
padding-left: 10px;
}

input[type="text"]{
font-size: 14px;
font-family: 'Akrobat SemiBold';
letter-spacing: 0.03rem;
}

button{
width: 45px;
position: absolute;
left:65%;
border:none;
border-radius: 3px;
background-color: #80bd01;
font-size: 12px;
font-family: 'Akrobat SemiBold';
color: white;
cursor: pointer;
}
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmb = styled.div`
width: 97%;
height: 260px;
position: relative;
margin-right: auto;
margin-left: auto;
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbHeader = styled.div`
width: 100%;
height: 122px;
margin-top: 10px;
position: relative;
margin-bottom: 50px;
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbHeaderTitle = styled.div`
width: 100%;
height: 35px;
background-color: #80bd01;
display: flex;
justify-content: space-between;
align-items: center;
p{
width: 65%;
height: 20px;
text-align: right;
font-size: 18px;
font-family: 'Akrobat';
letter-spacing: 0.03rem;
color: white;
}

span{
margin-right: 5px;
}
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbHeaderLoading = styled.div`
width: 100%;
height: 30px;
position: relative;
display: flex;
justify-content: center;
img{
width: 160px;
height: 20px;
display: flex;
object-fit: cover;
}
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbHeaderConfig = styled.div`
width: 100%;
height: 100%;
// background-color: #8EC505;
display: flex;
justify-content: space-between;
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbHeaderConfigImage = styled.div`
width: 136px;
height: 100%;
// background-color: #f20000;
display: flex;
align-items: center;
img{
width: 130px;
object-fit: scale-down;
}
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbHeaderConfigOptions = styled.div`
width: 180px;
height: 100%;
margin-right: 2px;
// background-color: #8EC505;
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbHeaderConfigOptionsField = styled.div`
width: 98%;
height: 33px;
position: relative;
border-radius: 2px;
margin-top: 10px;
background-color: white;
display: flex;
align-items: center;

.large{
width: 315px;
height: 33px;
z-index: 1;
}


.large-height{
height: 54px;
}

p{
font-size: 15px;
font-family: 'Akrobat';
color: rgb(61, 61, 61);
padding-left: 10px;
}

&:nth-child(2n+1){
background-color: #f2f2f2;
}

select{
width: 100%;
height: 100%;
border: none;
outline: none;
-webkit-appearance: none;
-moz-appearance: none;
background-image: url("/images/arrow-down-green.png");
background-size: 15px 10px;
background-repeat: no-repeat;
background-position-x: 96%;
background-position-y: 50%;
background-color: transparent;
padding-left: 10px;
font-size: 14px;
font-family: 'Akrobat';
color: rgb(61, 61, 61);

}

input{
width: 80%;
height: 60%;
position: relative;
margin-left: auto;
margin-right: auto;
border-radius: 3px;
border: 0.3px solid rgb(174, 174, 174);
background-color: white;
font-size: 14px;
font-family: 'Akrobat SemiBold';
letter-spacing: 0.03rem;
outline: none;
-webkit-appearance: none;
-moz-appearance: none;
padding-left: 10px;
}

input[type="text"]{
font-size: 14px;
font-family: 'Akrobat SemiBold';
letter-spacing: 0.03rem;
}


.cep{

input{
width: 80%;
height: 60%;
position: relative;
margin-left: auto;
margin-right: auto;
border-radius: 3px;
font-size: 14px;
font-family: 'Akrobat SemiBold';
letter-spacing: 0.03rem;
border: 0.3px solid rgb(174, 174, 174);
background-color: white;
outline: none;
-webkit-appearance: none;
-moz-appearance: none;
padding-left: 10px;
}

input[type="text"]{
font-size: 14px;
font-family: 'Akrobat SemiBold';
letter-spacing: 0.03rem;
}

button{
width: 45px;
position: absolute;
left:65%;
border:none;
border-radius: 3px;
background-color: #80bd01;
font-size: 12px;
font-family: 'Akrobat SemiBold';
color: white;
cursor: pointer;
}
}
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbHeaderConfigOptionsCub = styled.div`
width: 98%;
height: 33px;
display: flex;
align-items: center;
margin-top: 10px;
button{
width: 100%;
height: 100%;
border-radius: 3px;
border: 0.6px solid rgb(177, 177, 177);
background-color: white;
display: flex;
justify-content: flex-start;

p{
align-self: center;
font-size: 16px;
font-family: 'Akrobat';
color: rgb(61, 61, 61);
margin-left: 10px;
.tooltiptext {
visibility: hidden;
width: 620px;
background-color: #555;
color: #fff;
text-align: center;
border-radius: 6px;
padding: 5px 0;
position: absolute;
z-index: 99999;
top: 108%;
left: 120%;
margin-left: -60px;
opacity: 0;
transition: opacity 0.3s;

table{
width: 100%;
z-index: 99999;
font-size: 12px;
font-family: 'Akrobat';
}
}

.tooltiptext::after {
content: "";
position: absolute;
top: 0%;
left: 0%;
margin-left: -5px;
border-width: 5px;
border-style: solid;
z-index: 999999;
opacity: 1;
border-color: #555 transparent transparent transparent;
}
}

p:hover .tooltiptext {
visibility: visible;
opacity: 1;
z-index: 999999;
}

span{
background-position-x: 0px;
background-position-y: 8px;
}
}
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbConfig = styled.div`
width: 98%;
height: 95px;
position: relative;
// background-color: #bebebe;
display: flex;
justify-content: space-between;
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbConfigColumn = styled.div`
width: 130px;
height: 100%;
// background-color: tan;

.large{
width: 175px;
}
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbConfigColumnField = styled.div`
width: 100%;
height: 33px;
position: relative;
border-radius: 2px;
margin-bottom: 5px;
background-color: white;
display: flex;
align-items: center;

.large{
width: 315px;
height: 33px;
z-index: 1;
}


.large-emb{
width: 324px;
height: 40px;
z-index: 1;
}

.large-height{
height: 54px;
}

.large-height-emb{
height: 61px;
}

p{
font-size: 15px;
font-family: 'Akrobat';
color: rgb(61, 61, 61);
padding-left: 10px;

strong{
color: #f20000;
}
}

&:nth-child(2n+1){
background-color: #f2f2f2;
}

.transparent{
background-color: transparent;
}
select{
width: 100%;
height: 100%;
border: none;
outline: none;
-webkit-appearance: none;
-moz-appearance: none;
background-image: url("/images/arrow-down-green.png");
background-size: 15px 10px;
background-repeat: no-repeat;
background-position-x: 96%;
background-position-y: 50%;
background-color: transparent;
padding-left: 10px;
font-size: 14px;
font-family: 'Akrobat';
color: rgb(61, 61, 61);
}

input{
width: 80%;
height: 60%;
position: relative;
margin-left: auto;
margin-right: auto;
border-radius: 3px;
border: 0.3px solid rgb(174, 174, 174);
background-color: white;
font-size: 14px;
font-family: 'Akrobat SemiBold';
letter-spacing: 0.03rem;
outline: none;
-webkit-appearance: none;
-moz-appearance: none;
padding-left: 10px;
}

input[type="text"]{
font-size: 14px;
font-family: 'Akrobat SemiBold';
letter-spacing: 0.03rem;
}

.cep{

input{
width: 80%;
height: 60%;
position: relative;
margin-left: auto;
margin-right: auto;
border-radius: 3px;
font-size: 14px;
font-family: 'Akrobat SemiBold';
letter-spacing: 0.03rem;
border: 0.3px solid rgb(174, 174, 174);
background-color: white;
outline: none;
-webkit-appearance: none;
-moz-appearance: none;
padding-left: 10px;
}

input[type="text"]{
font-size: 14px;
font-family: 'Akrobat SemiBold';
letter-spacing: 0.03rem;
}

button{
width: 45px;
position: absolute;
left:65%;
border:none;
border-radius: 3px;
background-color: #80bd01;
font-size: 12px;
font-family: 'Akrobat SemiBold';
color: white;
cursor:  pointer;
}
}
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbConfigColumnLarge = styled(RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbConfigColumn)`
width: 175px;
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductSubtitle = styled.div`
width: 97%;
height: 30px;
margin-top: 5px;
margin-bottom: 5px;
position: relative;
margin-left: auto;
margin-right: auto;
background-color: #80bd01;
display: flex;
justify-content: center;
align-items: center;
p{
font-size: 15px;
font-family: 'Akrobat SemiBold';
color:white;
}
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFrete = styled.div`
width: 97%;
height: 280px;
position: relative;
margin-right: auto;
margin-left: auto;
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteDigiteCep = styled.div`
width: 100%;
height: 120px;
position: relative;
margin-right: auto;
margin-left: auto;
display: flex;
justify-content: space-between;
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteDigiteCepColumn = styled.div`
width: 130px;
height: 100%;
// background-color: tan;    

`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteDigiteCepColumnField = styled.div`
width: 100%;
height: 33px;
position: relative;
border-radius: 2px;
margin-bottom: 5px;
background-color: white;
display: flex;
align-items: center;

.large-emb{
width: 324px;
height: 40px;
z-index: 1;
}

.large-height{
height: 54px;
}

.large-height-emb{
height: 61px;
}

p{
font-size: 15px;
font-family: 'Akrobat';
color: rgb(61, 61, 61);
padding-left: 10px;

strong{
color: #f20000;
}
}

&:nth-child(2n+1){
background-color: #f2f2f2;
}

.transparent{
background-color: transparent;
}
select{
width: 100%;
height: 100%;
border: none;
outline: none;
-webkit-appearance: none;
-moz-appearance: none;
background-image: url("/images/arrow-down-green.png");
background-size: 15px 10px;
background-repeat: no-repeat;
background-position-x: 96%;
background-position-y: 50%;
background-color: transparent;
padding-left: 10px;
font-size: 14px;
font-family: 'Akrobat';
color: rgb(61, 61, 61);
}

input{
width: 80%;
height: 60%;
position: relative;
margin-left: auto;
margin-right: auto;
border-radius: 3px;
border: 0.3px solid rgb(174, 174, 174);
background-color: white;
font-size: 14px;
font-family: 'Akrobat SemiBold';
letter-spacing: 0.03rem;
outline: none;
-webkit-appearance: none;
-moz-appearance: none;
padding-left: 10px;
}

input[type="text"]{
font-size: 14px;
font-family: 'Akrobat SemiBold';
letter-spacing: 0.03rem;
}

`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteDigiteCepColumnFieldLarge = styled(RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteDigiteCepColumnField)`
width: 330px;
height: 42px;
z-index: 1;
background-color: transparent;    
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteDigiteCepColumnFieldCep = styled(RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteDigiteCepColumnField)`    
input{
width: 80%;
height: 60%;
position: relative;
margin-left: auto;
margin-right: auto;
border-radius: 3px;
font-size: 14px;
font-family: 'Akrobat SemiBold';
letter-spacing: 0.03rem;
border: 0.3px solid rgb(174, 174, 174);
background-color: white;
outline: none;
-webkit-appearance: none;
-moz-appearance: none;
padding-left: 10px;
}

input[type="text"]{
font-size: 14px;
font-family: 'Akrobat SemiBold';
letter-spacing: 0.03rem;
}

button{
width: 45px;
position: absolute;
left:65%;
border:none;
border-radius: 3px;
background-color: #80bd01;
font-size: 12px;
font-family: 'Akrobat SemiBold';
color: white;
}
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGrid = styled.div`
width: 100%;
height: 280px;
position: relative;
margin-left: auto;
margin-right: auto;
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContent = styled.div`
width: 100%;
height: 185px;
position: relative;
display: flex;
justify-content: space-around;
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumn = styled.div`
width: 32%;
height: 100%;
position: relative;
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCel = styled.div`
width: 100%;
height: 32px;
margin-top: 5px;
margin-bottom: 5px;
border-radius: 3px;
display: flex;
justify-content: center;
align-items: center;

&:nth-child(1){
margin-top: 2px;
background-color: transparent;
}

&:nth-child(2){
text-align: center;
}

p{
max-width: 97%;
font-size: 13px;
font-family: 'Akrobat';
color: rgb(61, 61, 61);
}

img{
width: 98%;
position: relative;
margin-left: auto;
margin-right: auto;
}

.selo-gratis{
width: 57px;
height: 23px;
}

input{
width: 25px;
height: 25px;
border: none;
outline: none;
text-decoration: none;
}

input[type=radio]:checked:before {
content: "";
display: block;
position: relative;
outline: none;
width: 25px;
height: 25px;
left:-1px;
top:-1px;
border: 0.6px solid #80bd01;
border-radius: 15px;
background: url('../images/icon-checked-white.png');
background-color: white;
background-size: 100% 100%;
}


`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCelColorGray = styled(RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCel)`
background-color: #EAEAEA;
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridResumo = styled.div`
width: 100%;
height: 80px;
position: relative;
display: flex;
align-items: center;
border-radius: 3px;
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridResumoContent = styled.div`
width: 88%;
height: 90%;
position: relative;
margin-left: auto;
margin-right: auto;
display: flex;
align-self: center;
flex-direction: column;
margin-top: 5px;
top: 2px;
`;
export const RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridResumoContentRow = styled.div`
width: 100%;
height: 20px;
display: flex;
justify-content: space-between;

p{
font-size: 15px;
font-family: 'Akrobat';
color: rgb(61, 61, 61);
}

strong{
font-size: 16px;
font-family: 'Akrobat ExtraBold';
letter-spacing: 0.03rem;
color: #80bd01;
}
`;
export const RegisterBudgetContentDataProductControl = styled.div`
width: 97%;
height: auto;
position: relative;
margin-right: auto;
margin-left: auto;
z-index: 999999;
margin-bottom: 10px;
// background-color: skyblue;
button{
width: 100%;
height: 30px;
background-color: #ff7e00;
border: none;
border-radius: 3px;
margin-top: 5px;

cursor: pointer;
display: flex;
justify-content: center;
align-items: center;

p{
font-size: 14px;
font-family: 'Akrobat';
color: white;
}
img{
// width: 150px;
height: 100%;
display: flex;
object-fit: scale-down;
}
}

`;
export const RegisterBudgetContentDataProductControlLoading = styled.div`
width: 100%;
height: 30px;
position: relative;
display: flex;
justify-content: center;
img{
width: 160px;
height: 20px;
display: flex;
object-fit: cover;
}
`;
export const RegisterBudgetContentDataProductControlGrid = styled.div`
width: 100%;
height: 70px;
margin-top: 5px;
display: flex;
justify-content: center;
z-index: 999999;
`;
export const RegisterBudgetContentDataProductControlGridColumn = styled.div`
width: 65px;
height: 100%;
position: relative;
flex-direction: column;
z-index: 999999;
margin-left: 1px;
&:nth-child(2){
border-right: none;
}
`;
export const RegisterBudgetContentDataProductControlGridColumnItem = styled.div`
width: 100%;
height: 50%;
align-items: center;
text-align: center;
background-color: white;
border-right: 1px solid #80bd01;
z-index: 999999;

&:nth-child(1){
background-color: #80bd01;
border-right: .5px solid white;
margin-bottom: 2px;
cursor: pointer;
}



input{
width: 30px;
height: 30px;
border: none;
outline: none;
cursor: pointer;
}


input[type=radio]:checked:before {
content: "";
display: block;
position: relative;
outline: none;
width: 30px;
height: 30px;
border-radius: 15px;
background: url('../images/icon-checked-white.png');
background-color: white;
background-size: 100% 100%;
}

span{
width: 30px;
position: relative;
margin-left: auto;
margin-right: auto;
text-align: center;
}

p{
font-size: 13px;
font-family: 'Akrobat SemiBold';
color: #80bd01;
}
`;
export const RegisterBudgetContentDataProductControlGridColumnItemLast = styled(RegisterBudgetContentDataProductControlGridColumnItem)`
border-right: none;
`;
export const RegisterBudgetContentDataProductBodyFooter = styled.div`
width: 100%;
height: 35px;
display: none;
background-color: white;
`;
export const RegisterBudgetContentDataProductBodyFooterContent = styled.div`
width: 580px;
height: 100%;
position: relative;
float: right;
background: linear-gradient(to right, white, #ffa74f,#ff7e00,#ff7e00);
display: flex;
align-items: center;
justify-content: flex-end;
p{
font-size: 18px;
font-family: 'Akrobat';
color: white;
padding-right: 10px;
text-align: right;
cursor: pointer;
}
`;
export const RegisterBudgetContentDataProductBodyFooterContentDataTMK = styled.div`
width: 100%;
min-height: 40px;
margin-top: 10px;
`;
export const RegisterBudgetContentDataProductBodyFooterContentDataTMKHeader = styled.div`
width: 100%;
height: 34px;
display: flex;
justify-content: flex-start;
align-items: center;
background-color: #80bd01;
span{
cursor: pointer;
}
`;
export const RegisterBudgetContentDataProductBodyFooterContentDataTMKHeaderTitle = styled.div`
width: 150px;
height: 30px;
margin-left: 20px;
margin-right: 20px;
display: flex;
align-items: center;
cursor: pointer;
p{
font-size: 18px;
font-family: 'Akrobat';
color: white;
strong{
font-size: 18px;
font-family: 'Akrobat ExtraBold';
color: white;
}
}
`;
export const RegisterBudgetContentDataProductBodyFooterContentDataTMKBody = styled.div`
width: 100%;
height: auto;
`;
export const RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContent = styled.div`
width: 98%;
height: 100%;
position: relative;
margin-left: auto;
margin-right: auto;
`;
export const RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentHeader = styled.div`

width: 100%;
height: 70px;
// background-color: aquamarine;
display: flex;
align-items: center;
`;
export const RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentHeaderContent = styled.div`
width: 80%;
height: 35px;
position: relative;
margin-left: auto;
margin-right: auto;
// background-color: brown;
display: flex;
justify-content: space-between;
label{
// width: 100px;
font-size: 16px;
font-family: 'Akrobat';
color: rgb(61, 61, 61);
}
`;
export const RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentHeaderContentField = styled.div`
display: flex;
justify-content: space-between;
align-items: center;
label{
margin-left: 1rem;
// width: 100px;
font-size: 16px;
font-family: 'Akrobat';
color: rgb(61, 61, 61);
margin-right: 5px;
}
select{
// width: 100%;
max-width: 250px;
border: 0.6px solid rgba(61, 61, 61, 0.131);
outline: none;
-webkit-appearance: none;
-moz-appearance: none;
padding-left: 10px;
font-size: 16px;
font-family: 'Akrobat';
color: rgb(61, 61, 61);
}

input{
width: 120px;
position: relative;
text-align: center;
border: 0.6px solid gray;
border-radius: 3px;
font-size: 16px;
font-family: 'Akrobat';
outline: none;
}

input[type=checkbox]{
width: 20px;
height: 20px;
position: relative;
text-align: center;
border: 0.6px solid rgba(61, 61, 61, 0.131);
border-radius: 3px;
font-size: 16px;
font-family: 'Akrobat';
outline: none;
}
`;
export const InputDataRetorno = styled(Input)`
height: 30px;
position: relative;
text-align: center;
border: 0.6px solid rgba(61, 61, 61, 0.131);
border-radius: 3px;
font-size: 16px;
font-family: 'Akrobat';
outline: none;
`;
export const RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentRow = styled.div`
width: 100%;
height: 80px;
// background-color: aquamarine;
display: flex;
align-items: center;
`;
export const RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentRowContent = styled.div`
width: 95%;
height: 60px;
position: relative;
margin-left: auto;
margin-right: auto;
// background-color: brown;
// display: flex;
// justify-content: space-between;
border: 0.6px solid rgba(61, 61, 61, 0.131);
border-radius: 3px;
`;
export const RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentRowContentHighlight = styled.span`
width: 133px;
height: 19px;
position: absolute;
float: left;
background-color: #80bd01;
border-radius: 3px;
color: white;
font-size: 14px;
font-family: 'Akrobat';
margin-top: 3px;
margin-left: 5px;
z-index: 999;
text-align: center;
`;
export const RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentRowContentInput = styled.textarea`
width: 933px;
height: 55px;
font-size: 13px;
font-family: 'Akrobat';
line-height: 1;
letter-spacing: 0.05rem;
line-height: 18px;
border: 0;
top: 2px;
position: relative;
float: left;
margin-left: 5px;    
color: #919aae;
text-transform: uppercase;
background: transparent;
outline: none;
text-align: left;
text-indent: 140px;
resize: none;
`;
export const RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentRowContentButton = styled.div`
width: 300px;
height: 100%;
position: relative;
float: left;
// background-color: #8EC505;
display: flex;
align-items: center;
button{
width: 228px;
height: 33px;
border: none;
border-radius: 5px;
background-color: #8EC505;
font-size: 14px;
font-family: 'Akrobat';
color: white;
cursor: pointer;
}
`;
export const RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentGrid = styled.div`
width: 100%;
margin-top: 25px;
`;
export const RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentGridContent = styled.div`
width: 95%;
min-height: 500px;
position: relative;
margin-left: auto;
margin-right: auto;
// background-color: sienna;
`;
export const RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentGridContentCard = styled.div`
width: 100%;
height: 115px;
border-radius: 5px;
background-color: white;
box-shadow: 2px 2px 7px 2px rgba(165, 165, 165, 0.493);
display: flex;
flex-direction: column;
margin-bottom: 15px;
`;
export const RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentGridContentCardHeader = styled.div`
width: 99%;
height: 54px;
position: relative;
margin-left: auto;
margin-right: auto;
margin-top: 5px;
background-color: #f9f9f9;
display: flex;
flex-direction: row;
justify-content: space-between;
align-items: center;
`;
export const RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentGridContentCardHeaderColumn = styled.div`
height: 100%;
height: 70%;
display: flex;
flex-direction: column;
align-items: center;
margin-left: 10px;
margin-right: 10px;
p{
font-size: 14px;
font-family: 'Akrobat SemiBold';
color: #80bd01;
text-align: left;
&:nth-child(2){
color: rgb(61, 61, 61);
}
}
`;
export const RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentGridContentCardObs = styled.div`
width: 99%;
height: 35px;
position: relative;
margin-left: auto;
margin-right: auto;
margin-top: 5px;
display: flex;
justify-content: flex-start;
p{
width: 990px;
margin-top: 3px;
}
`;
export const RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentGridContentCardObsHighlights = styled.span`
width: 133px;
height: 19px;
position: relative;
float: left;
background-color: #80bd01;
border-radius: 3px;
color: white;
font-size: 14px;
font-family: 'Akrobat';
margin-top: 3px;
margin-left: 0px;
margin-right: 5px;
z-index: 999;
text-align: center;
`;
export const RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentRowInformationPlus = styled.a`
display: flex;
align-items: center;
text-decoration: none;
font-size: 14px;
color: #80bd01;
font-family: 'Akrobat SemiBold';
cursor: pointer;

.icon {
margin-right: 5px;
}

&__divisor{
width: 70px;
}
&__divisor-button{
width: 10px;
}
`;
export const ContentMarginBottom = styled.div`
width: 100%;
height: 80px;
background-color: transparent;
`;
export const BudgetFooter = styled.div`
width: 100%;
height: 70px;
position: fixed;
background: linear-gradient(to bottom, #e6e6e6, #f9f9f9,white);
box-shadow: 1px 1px 5px 1px white;
border-top: 1px solid white;
z-index: 999;
`;
export const BudgetFooterContent = styled.div`
width: 1366px;
height: 100%;
position: relative;
margin-left: auto;
margin-right: auto;
background: linear-gradient(to bottom, #e6e6e6, #f9f9f9,white);
display: flex;
justify-content: flex-end;
align-items: center;
`;
export const BudgetFooterContentItem = styled.div`
width: 207px;
height: 40px;
position: relative;
display: flex;
justify-content: center;
align-items: center;
cursor: pointer;
p{
font-size: 16px;
font-family: 'Akrobat';
color: rgb(61, 61, 61);
margin-left: 8px;
strong{
font-family: 'Akrobat ExtraBold';
}
}
`;
export const BudgetFooterContentDivisor = styled.div`
width: 1.5px;
height: 90%;
position: relative;
margin-left: 5px;
margin-right: 5px;
background: linear-gradient(to bottom, white,white,#f0f0f0, #e6e6e6);
box-shadow: 2px 2px 5px 2px #e6e6e6;
transform: rotate(15deg);
`;
export const RegisterBudgetModalContentAbaProduto = styled(RegisterBudgetModalContent)`
width: 1070px;
height: 80%;
position: relative;
margin-left: auto;
margin-right: auto;
-webkit-align-self: center;
-ms-flex-item-align: center;
align-self: center;
top: 0px;
left: 0px;
box-shadow: 2px 2px 15px 2px rgb(228 228 228 / 49%);
background-color: #ffffff;
font-family: Akrobat;
overflow-y: scroll;
`;
export const RegisterBudgetModalContentFilterProduct = styled(RegisterBudgetModalContentFilter)`
height: 80px;
position: relative;
margin-left: auto;
margin-right: auto;
display: flex;
justify-content: center;
margin-top: 20px;
color: #ff7e00;
`;
export const RegisterBudgetResumeContentFilterSelectorProduct = styled(RegisterBudgetResumeContentFilterSelector)`
background-color: #fff;
-webkit-border-radius: 3px;
-moz-border-radius: 3px;
border-radius: 3px;
padding: 0 5px;
font-size: 16px;
font-family: 'Akrobat ExtraBold';
letter-spacing: 0.03rem;
margin: 0 10px;
display: flex;
align-items: center;
position: relative;
top: -20px;

input {
height: 32px;
border: 1px solid #919aae;
color: #919aae;
margin-left: 3px;
border-radius: 3px;
outline: none
}
label{
font-family: Akrobat ExtraBold;
}
`;
export const RegisterBudgetProdutoGridProdutos = styled.div`
width: 80%;
font-family: Akrobat;
max-width: 1100px;
height: 70vw;
min-height: 1200px;
// max-height: 990px;
position: relative;
z-index: 997;
margin-left: auto;
margin-right: auto;
justify-content: space-evenly;
top: 2vw;
// background-color: aquamarine;
`;
export const RegisterBudgetModalContentHeader = styled.div`
width: 100%;
height: 30px;
background-color: #ff7e00;
display: flex;
justify-content: center;
align-items: center;
font-family: Akrobat;
p{
font-size: 16px;
color: white;
letter-spacing: 0.03rem;
font-family: 'Akrobat SemiBold';
}
span{
position: absolute;
top:3px;
left: 90%;
float: right;
font-size: 18px;
font-family: 'Akrobat';
color: white;
cursor: pointer;
}
`;
export const RegisterBudgetModalContentDataProduct = styled.div`
width: 70%;
font-family: Akrobat;
height: 200px;
position: relative;
margin-left: auto;
margin-right: auto;
// background-color: aquamarine;
display: flex;
justify-content: space-between;
align-items: center;
`;
export const RegisterBudgetModalContentDataProductCardImage = styled.div`
width: 165px;
height: 100%;
// background-color: chartreuse;
display: flex;
align-items: center;
img{
width: 141px;
border-radius: 3px;
border: 0.3px solid rgba(61, 61, 61, 0.131);
}
`;
export const RegisterBudgetModalContentDataProductInfos = styled.div`
width: 375px;
height: 160px;
`;
export const RegisterBudgetModalContentDataProductInfosTitle = styled.div`
width: 100%;
height: 35px;

p{
font-size: 18px;
color: rgb(61, 61, 61);
margin-left: 10px;
}
`;
export const RegisterBudgetModalContentDataProductInfosLine = styled.div`
width: 100%;
height: 40px;
display: flex;
justify-content: space-between;
`;
export const RegisterBudgetModalContentDataProductInfosLineBlock = styled.div`
width: 45%;
height: 35px;
background-color: #f2f2f2;
border-radius: 3px;
display: flex;
align-items: center;

&--none-bg-color{
background-color: transparent;
}
p{
font-size: 16px;
color: rgb(61, 61, 61);
margin-left: 8px;
}
`;
export const RegisterBudgetModalContentDataProductInfosLineBlockNoneBgColor = styled(RegisterBudgetModalContentDataProductInfosLineBlock)`

background-color: transparent;
`;
export const RegisterBudgetModalContentDataGrid = styled.div`
width: 70%;
height: 300px;
position: relative;
margin-left: auto;
margin-right: auto;
`;
export const RegisterBudgetModalContentDataGridControl = styled.div`
width: 100%;
height: 100px;
display: flex;
flex-direction: column;
align-items: center;

button{
width: 197px;
height: 51px;
background-color: #80bd01;
font-size: 20px;
font-family: 'Akrobat';
color: #f9f9f9;
border:none;
border-radius: 5px;
cursor: pointer;
}

input{
width: 197px;
height: 51px;
background-color: #81bd0142;
font-size: 20px;
font-family: 'Akrobat';
position: absolute;
opacity: 0;
z-index: 999;
color: #f9f9f9;
border:none;
border-radius: 5px;
cursor: pointer;
}

p{
font-size: 18px;
font-family: 'Akrobat';
color: rgb(61, 61, 61);
margin-top: 15px;
}
`;
export const RegisterBudgetModalContentDataGridTable = styled.div`
width: 99%;
height: 195px;
background-color: white;
border: 0.3px solid rgba(61, 61, 61, 0.131);

thead{
font-size: 16px;
font-family: 'Akrobat';
color: black;
position: relative;
left: 135px;
th{
border: 10px solid transparent;
}
}

tbody{
position: relative;
left: 135px;
td{
height: 10px;
font-size: 16px;
font-family: 'Akrobat';
color: black;
position: relative;
text-align: center;
a{
color: #80bd01;
}
}
}
`;
export const RegisterBudgetModalContentFooter = styled.div`
width: 100%;
height: 80px;
position: relative;
margin-left: auto;
margin-right: auto;
display: flex;
justify-content: center;
align-items: center;

button{
width: 197px;
height: 51px;
background-color: #ff7e00;
font-size: 20px;
font-family: 'Akrobat';
color: #f9f9f9;
border:none;
border-radius: 5px;
cursor: pointer;
}
`;
export const RegisterBudgetProdutoGridProdutosProduto = styled.div`
width: 200px;
height: 550px;
position: relative;
float: left;
text-align: center;
font-family: 'Akrobat';
font-size: 120%;
display: block;
margin-left: 50px;
// background-color: cadetblue;
`;
export const RegisterBudgetProdutoGridProdutosTitle = styled.div`
font-size: 17px;
height: 60px;
color: rgb(61, 61, 61);
// font-family: 'Akrobat';
font-family: Gisha bold;
// white-space: nowrap;
text-align: center;

strong{
width: 200px;
height: 45px;
font-weight: bolder;
position: relative;
}

h1{
font-size: 15px;
height: 20px;
line-height: 100%;
font-family: 'Gisha bold';
}
p{
font-size: 16px;
position: relative;
font-weight: 100;
font-family: 'Gisha';
}
`;
export const RegisterBudgetProdutoGridProdutosCardProd = styled.div`
width: 100%;
height: 417px;
position: relative;
border: 0.6px solid #eeeeee;
// background-color: rgb(23, 223, 100);
`;
export const RegisterBudgetProdutoGridProdutosSeloEmbalagem = styled.div`
width: 196px;
height: 68px;
position: absolute;
top: 190px;
left:-15px;
background-image: url("/images/menu/EMBALAGEM-ESPECIAL.png");
background-repeat: no-repeat;
background-size: 100% 100%;
// background-color: burlywood;
`;
export const RegisterBudgetProdutoGridProdutosCardProdImageProd = styled.img`
width: 100%;
height: 247px;
position: relative;
float: left;
display: block;
object-fit: scale-down;
border: 0.6px solid #eeeeee;
cursor: pointer;
img{
width: 100%;
height: 100%;
display: block;
object-fit: scale-down;
border: 1px solid #eeeeee;
}
`;
export const RegisterBudgetProdutoGridProdutosCardProdSeloEmbalagem = styled.img`
width: 196px;
height: 68px;
position: absolute;
top: 190px;
left:-15px;
background-image: url("/images/menu/EMBALAGEM-ESPECIAL.png");
background-repeat: no-repeat;
background-size: 100% 100%;
// background-color: burlywood;
`;
export const RegisterBudgetProdutoGridProdutosCardProdDesc = styled.div`
width: 100%;
height: 50px;
display: block;
position: relative;
float: left;
color: rgb(61, 61, 61);
// background-color: #f05423;

p{
width: 175px;
position: relative;
margin-left: auto;
margin-right: auto;
text-align: left;
line-height: 150%;
font-size: 11px;
font-family: 'Gisha';
top: 12px;
color: rgb(61, 61, 61);
}

`;
export const RegisterBudgetProdutoGridProdutosCardProdCores = styled.div`
width: 100%;
height: 108px;
display: block;
position: relative;
float: left;
margin-top: 10px;
// background-color: #f05423;            
`;
export const RegisterBudgetProdutoGridProdutosCardProdCoresTitle = styled.div`
width: 100%;
height: 18px;
position: relative;
color: rgb(61, 61, 61);
// background-color: aqua;

p{
width: 174px;
height: 100%;
position: relative;
margin-left: auto;
margin-right: auto;
font-size: 12.5px;
font-family: 'Akrobat';
text-align: left;
color: rgb(61, 61, 61);
}          
`;
export const RegisterBudgetProdutoGridProdutosCardProdCoresGridCores = styled.div`
width: 100%;
height: 50px;
position: relative;
float: left;
// background-color: rgb(238, 144, 30);        
`;
export const RegisterBudgetProdutoGridProdutosCardProdCoresGridCoresContent = styled.div`
width: 100px;
height: 100px;
position: relative;
left:10px;
z-index: 999;
// background-color: rgba(165, 42, 42, 0.349);       
`;
export const RegisterBudgetProdutoGridProdutosCardProdCoresGridCoresContentCor = styled.div`
width: 14px;
height: 14px;
position: relative;
float: left;
margin-left: 6px;
margin-top: 6px;
border-radius: 14px;

.tooltip-inner {
background-color: #00acd6 !important;
/*!important is not necessary if you place custom.css at the end of your css calls. For the purpose of this demo, it seems to be required in SO snippet*/
color: #fff;
}    
`;
export const RegisterBudgetProdutoGridProdutosCardProdValor = styled.div`
width: 100%;
height: 48px;
display: block;
position: relative;
float: left;
margin-left: auto;
margin-right: auto;
top: -50px;
color: rgb(61, 61, 61);
// background-color: burlywood;
`;
export const RegisterBudgetProdutoGridProdutosCardProdValorContent = styled.div`
width: 170px;
height: 100%;
position: relative;
margin-left: auto;
margin-right: auto;
p{
height: 8px;
line-height: 130%;
font-size: 11px;
font-family: 'Gisha';
text-align: right;
color: rgb(61, 61, 61);
}

strong{
font-size: 18px;
letter-spacing: -0.02rem;
font-family: 'Gisha bold';
color: rgb(61, 61, 61);
}
`;
export const RegisterBudgetProdutoGridProdutosProdutoBNTConferirDisponivel = styled.div`
width: 100%;
height: 50px;
position: relative;
top: -40px;
cursor: pointer;
// background-color: rgb(255, 94, 0);

button{
width: 100%;
height: 27px;
position: relative;
top: 10px;
border: none;
border-radius: 2px;
letter-spacing: 0.05rem;
background-color: #dfdfdf;
font-size: 17px;
font-family: 'Akrobat';
color: #4d4d4d;
font-weight: 400px;
}
`;
export const RegisterBudgetProdutoGridProdutosProdutoBNTConferir = styled.div`
width: 100%;
height: 50px;
position: relative;
top: -40px;
cursor: pointer;
// background-color: rgb(255, 94, 0);

button{
width: 100%;
height: 27px;
position: relative;
top: 10px;
border: none;
border-radius: 2px;
letter-spacing: 0.05rem;
// background-color: #ff7e00;
background-color: #ff7e00;
font-size: 18px;
font-family: 'Akrobat';
color: white;
font-weight: 400px;
}
`;
export const RegisterBudgetContentDataCustomer = styled.div`
width: 100%;
min-height: 40px;
margin-top: 10px;
`;
export const RegisterBudgetContentDataCustomerHeader = styled.div`
width: 100%;
height: 34px;
display: flex;
justify-content: flex-start;
align-items: center;
background-color: #80bd01;
span{
cursor: pointer;
}
`;
export const RegisterBudgetContentDataCustomerHeaderTitle = styled.div`
width: 150px;
height: 30px;
margin-left: 20px;
margin-right: 20px;
display: flex;
align-items: center;
cursor: pointer;
p{
font-size: 18px;
font-family: 'Akrobat';
color: white;
strong{
font-size: 18px;
font-family: 'Akrobat ExtraBold';
color: white;
}
}
`;
export const RegisterBudgetContentDataCustomerBody = styled.div`
width: 100%;
height: auto;
`;
export const RegisterBudgetContentDataCustomerBodyContent = styled.div`
width: 100%;
height: 100%;
display: none;
`;
export const RegisterBudgetContentDataCustomerBodyContentRow = styled.div`
width: 97%;
height: 35px;
display: flex;
justify-content: flex-start;
align-items: center;
position: relative;
margin-left: auto;
margin-right: auto;
// background-color: salmon;

.gray{
width: 98%;
height: 60px;
border-radius: 3px;
background-color: #f9f9f9;
}

.btn{
width: 98%;
margin-top: 10px;
}
`;
export const RegisterBudgetContentDataCustomerBodyContentRowSelectField = styled.div`
width: 377px;
height: 100%;
display: flex;
justify-content: center;
align-items: center;
// menor valor * 100 / maior valor
label{
width: 24%;
height: 20px;
font-size: 14px;
color: rgb(61, 61, 61);
font-family: 'Akrobat';
// background-color: sandybrown;
}
`;
export const RegisterBudgetContentDataCustomerBodyContentRowSelectFieldField = styled.div`
width: 76%;
height: 25px;
border: 0.6px solid rgba(61, 61, 61, 0.131);
background-color: white;
display: flex;
justify-content: space-between;
align-items: center;
border-radius: 3px;
transition: 0.6s;
cursor: pointer;
.border-green{
transition: 0.6s;
border: 2px solid #80bd01;
}
`;
export const RegisterBudgetContentDataCustomerBodyContentRowSelectFieldFieldText = styled.div`
width: 90%;
height: 100%;
display: flex;
align-items: center;
cursor: pointer;
p{
font-size: 14px;
color: rgb(61, 61, 61);
padding-left: 20px;
font-family: 'Akrobat';
}
span{
}
`;
export const RegisterBudgetContentDataCustomerBodyContentRowButton = styled.div`
width: 112px;
height: 100%;
display: flex;
justify-content: center;
align-items: center;
// background-color: salmon;
button{
min-width: 96px;
height: 20px;
font-size: 11px;
border: none;
border-radius: 3px;
background-color: rgb(61, 61, 61);
font-family: 'Akrobat';
letter-spacing: 0.03rem;
color: white;
}
`;
export const RegisterBudgetContentDataCustomerBodyContentRowButtonMedium = styled(RegisterBudgetContentDataCustomerBodyContentRowButton)`
width: 155px;
justify-content: flex-start;
`;
export const RegisterBudgetContentDataCustomerBodyContentRowInformation = styled.div`
width: 320px;
height: 20px;
margin-left: 15px;
display: flex;
align-items: center;
justify-content: space-between;
// background-color: darkgreen;

p{
font-size: 14px;
font-family: 'Akrobat';
color: rgb(61, 61, 61);
strong{
font-size: 14px;
font-family: 'Akrobat ExtraBold';
color: rgb(61, 61, 61);
}
}
`;
export const RegisterBudgetContentDataCustomerBodyContentRowInformationPlus = styled.a`
display: flex;
align-items: center;
text-decoration: none;
font-size: 14px;
color: #80bd01;
font-family: 'Akrobat SemiBold';
cursor: pointer;

.icon {
margin-right: 5px;
}
`;
export const RegisterBudgetContentDataCustomerBodyContentRowGray = styled(RegisterBudgetContentDataCustomerBodyContentRow)`

width: 98%;
height: 60px;
border-radius: 3px;
background-color: #f9f9f9;

`;
export const RegisterBudgetContentDataCustomerBodyContentRowTextField = styled.div`
width: 24%;
height: 100%;
margin-left: 10px;
display: flex;
justify-content: space-between;
align-items: center;

&--small{
width: 11.5%;
}

p{
font-size: 14px;
font-family: 'Akrobat';
color: rgb(61, 61, 61);

strong{
color: #f20000;
font-family: 'Akrobat SemiBold';
}
}
`;
export const RegisterBudgetContentDataCustomerBodyContentRowTextFieldSmall = styled(RegisterBudgetContentDataCustomerBodyContentRowTextField)`
width: 11.5%;
`;
export const RegisterBudgetContentDataCustomerBodyContentRowButtonBTN = styled(RegisterBudgetContentDataCustomerBodyContentRow)`
width: 98%;
margin-top: 10px;
`;
export const RegisterBudgetContentDataCustomerBodyContentRowButtonRegister = styled.div`
width: 500px;
height: 100%;
display: flex;
justify-content: flex-start;
align-items: center;
// background-color: salmon;


button{
width: 409px;
height: 33px;
font-size: 11px;
border: none;
border-radius: 3px;
background-color: #ff7e00;
font-size: 14px;
font-family: 'Akrobat';
cursor: pointer;
letter-spacing: 0.03rem;
color: white;
}
`;
export const RegisterBudgetContentProposal = styled.div`
width: 100%;
min-height: 40px;
margin-top: 10px;
`;
export const RegisterBudgetContentProposalHeader = styled.div`
width: 100%;
height: 34px;
display: flex;
justify-content: flex-start;
align-items: center;
background-color: #80bd01;
span{
cursor: pointer;
}
`;
export const RegisterBudgetContentProposalHeaderTitle = styled.div`
width: 150px;
height: 30px;
margin-left: 20px;
margin-right: 20px;
display: flex;
align-items: center;
cursor: pointer;
p{
font-size: 18px;
font-family: 'Akrobat';
color: white;
strong{
font-size: 18px;
font-family: 'Akrobat ExtraBold';
color: white;
}
}
`;
export const RegisterBudgetContentProposalBody = styled.div`
width: 100%;
height: auto;
`;
export const RegisterBudgetContentProposalBodyContent = styled.div`
width: 98%;
height: 305px;
position: relative;
margin-left: auto;
margin-right: auto;
display: flex;
justify-content: space-between;

`;
export const RegisterBudgetContentProposalBodyContentColumn = styled.div`
width: 32%;
height: 100%;
display: flex;
flex-direction: column;
position: relative;
float: left;
// background-color: salmon;

.large{
width: 65%;
}

.gray{
width: 98%;
height: 60px;
border-radius: 3px;
background-color: #f9f9f9;
}

.btn{
width: 98%;
margin-top: 10px;
}
`;
export const RegisterBudgetContentProposalBodyContentColumnLarge = styled(RegisterBudgetContentProposalBodyContentColumn)`
width: 65%;
`;
export const RegisterBudgetContentProposalBodyContentColumnField = styled.div`
width: 377px;
height: 45px;
display: flex;
margin-top: 10px;
justify-content: center;
align-items: center;
// menor valor * 100 / maior valor
label{
width: 24%;
height: 20px;
font-size: 14px;
color: rgb(61, 61, 61);
font-family: 'Akrobat';
// background-color: sandybrown;
}

.custom{
margin-bottom: 10px;
label{
width: 120px;
}
}
`;
export const RegisterBudgetContentProposalBodyContentColumnSelectFieldField = styled.div`
width: 76%;
height: 25px;
border: 0.6px solid rgba(61, 61, 61, 0.131);
background-color: white;
display: flex;
justify-content: space-between;
align-items: center;
border-radius: 3px;
cursor: pointer;
&--border-none{
border: none;

input{
width: 20px;
height: 20px;
cursor: pointer;
}

input[type=radio]:checked:before {
content: "";
display: block;
position: relative;
width: 20px;
height: 20px;
border-radius: 15px;
background: url('/images/ok.png');
background-color: white;
background-size: 100% 100%;
cursor: pointer;
}
}
span{
cursor: pointer;
}
`;
export const RegisterBudgetContentProposalBodyContentColumnSelectFieldFieldArrow = styled(RegisterBudgetContentProposalBodyContentColumnSelectFieldField)`
span{
margin-right: 10px;
}
`;
export const RegisterBudgetContentProposalBodyContentColumnSelectFieldFieldSelect = styled.select`
width: 100%;
height: 100%;
border: none;
outline: none;
cursor: pointer;
-webkit-appearance: none;
-moz-appearance: none;
background-image: url("/images/arrow-down-green.png");
background-size: 15px 10px;
background-repeat: no-repeat;
background-position-x: 96%;
background-position-y: 50%;
background-color: transparent;
padding-left: 20px;
font-size: 14px;
font-family: 'Akrobat';
color: rgb(61, 61, 61);
`;
export const RegisterBudgetContentProposalBodyContentColumnSelectFieldFieldText = styled.div`
width: 90%;
height: 100%;
display: flex;
align-items: center;
p{
font-size: 14px;
color: rgb(61, 61, 61);
padding-left: 20px;
font-family: 'Akrobat';
}
`;
export const RegisterBudgetContentProposalBodyContentColumnSelectField = styled.div`
width: 377px;
height: 45px;
display: flex;
justify-content: center;
align-items: center;
// menor valor * 100 / maior valor
label{
width: 24%;
height: 20px;
font-size: 14px;
color: rgb(61, 61, 61);
font-family: 'Akrobat';
// background-color: sandybrown;
}

`;
export const RegisterBudgetContentProposalBodyContentColumnSelectFieldCustom = styled(RegisterBudgetContentProposalBodyContentColumnSelectField)`
margin-bottom: 10px;
margin-top: 15px;
label{
width: 120px;
}
`;
export const RegisterBudgetContentProposalBodyContentColumnSelectFieldFieldBorderNone = styled(RegisterBudgetContentProposalBodyContentColumnSelectFieldField)`
border: none;

input{
width: 20px;
height: 20px;
cursor: pointer;
}

input[type=radio]:checked:before {
content: "";
display: block;
position: relative;
width: 20px;
height: 20px;
border-radius: 15px;
background: url('/images/ok.png');
background-color: white;
background-size: 100% 100%;
cursor: pointer;
}
`;
export const RegisterBudgetContentProposalBodyContentColumnFunnel = styled.div`
width: 100%;
height: 91px;
`;
export const RegisterBudgetContentProposalBodyContentColumnFunnelContent = styled.div`
width: 57.5%;
height: 100%;
position: relative;
margin-left: auto;
margin-right: auto;

p{
font-size: 15px;
font-family: 'Akrobat';
color: #80bd01;
}

span{
font-size: 15px;
font-family: 'Akrobat';
color: rgb(61, 61, 61);
}
`;
export const RegisterBudgetContentProposalBodyContentColumnFunnelContentDetailsRow = styled.div`
display: flex;
justify-self: center;

.item{
width: 10px;
height: 10px;
background-color: #d4d4d4;
border-radius: 10px;
}
.green{
width: 10px;
height: 10px;
background-color: #80bd01;
border-radius: 10px;
}
.line{
width: 20px;
height: 1px;
position: relative;
top: 5px;
background-color: #d4d4d4;

}
.linegreen{
width: 20px;
height: 1px;
position: relative;
top: 5px;
background-color: #80bd01;
}

.star{
background-color: transparent;
}
`;

export const RegisterBudgetContentProposalBodyContentColumnFunnelContentDetailsDivisor = styled.div`
width: 100%;
height: 15px;
`;
export const RegisterBudgetContentProposalBodyContentColumnInfo = styled.div`
padding-left: 10px;
width: 95%;
height: 47px;
border-radius: 3px;
border: 0.6px solid rgba(61, 61, 61, 0.131);
position: relative;
margin-top: 18px;
margin-left: auto;
margin-right: auto;
display: flex;
background-color: white;

&:nth-child(1){
margin-top: 8px;
}
`;
export const RegisterBudgetContentProposalBodyContentColumnInfoText = styled.p`
color: #919aae;
font-weight: 400;
`;
export const RegisterBudgetContentProposalBodyContentColumnInfoTextFixedWidth = styled(RegisterBudgetContentProposalBodyContentColumnInfoText)`
width: 90%;
letter-spacing: 0.03rem;
`;
export const RegisterBudgetContentProposalBodyContentColumnInfoTextHighlights = styled.span`
width: 133px;
height: 19px;
position: absolute;
background-color: #80bd01;
border-radius: 3px;
color: white;
font-size: 14px;
font-family: 'Akrobat';
margin-top: 3px;
z-index: 999;
text-align: center;
`;
export const RegisterBudgetContentProposalBodyContentColumnInfoInputs = styled.p`
width: 70px;
font-size: 13px;
// line-height: 1;
// letter-spacing: -0.03rem;
border: 0;
height: 34px;
position: relative;
margin-top: auto;
margin-right: auto;
color: #919aae;
text-transform: uppercase;
background: transparent;
outline: none;
text-align: center;
`;
export const RegisterBudgetContentProposalBodyContentColumnInfoInputsTextArea = styled.textarea`
width: 70px;
font-size: 13px;
// line-height: 1;
// letter-spacing: -0.03rem;
border: 0;
height: 34px;
position: relative;
margin-top: auto;
margin-right: auto;
color: #919aae;
text-transform: uppercase;
background: transparent;
outline: none;
text-align: center;
`;
export const RegisterBudgetContentProposalBodyContentColumnInfoInputsObsTextarea = styled(RegisterBudgetContentProposalBodyContentColumnInfoInputsTextArea)`
width: 90%;
height: 90%;
font-size: 13px;
line-height: 1;
// letter-spacing: 0.03rem;
border: 0;
height: 34px;
top: 3px;
position: relative;
margin-top: auto;
margin-right: auto;
color: #919aae;
text-transform: uppercase;
background: transparent;
outline: none;
text-align: left;
text-indent: 140px;
resize: none;
`;
export const RegisterBudgetContentProposalBodyContentColumnInfoInputsObs = styled(RegisterBudgetContentProposalBodyContentColumnInfoInputs)`
width: 90%;
height: 90%;
font-size: 13px;
line-height: 1;
// letter-spacing: 0.03rem;
border: 0;
height: 34px;
top: 3px;
position: relative;
margin-top: auto;
margin-right: auto;
color: #919aae;
text-transform: uppercase;
background: transparent;
outline: none;
text-align: left;
text-indent: 140px;
resize: none;
`;